class ReasonImages {
    constructor(element) {
        Object.defineProperty(this, "slider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prevArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "captionsID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "captionsSlider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.slider = element.querySelector('.reason-images-slider');
        this.prevArrow = element.querySelector('.slick-slider-arrow-prev');
        this.nextArrow = element.querySelector('.slick-slider-arrow-next');
        this.captionsID = this.slider?.dataset.for;
        this.captionsSlider = document.querySelector(`#${this.captionsID}`);
        if (!this.slider || !this.prevArrow || !this.nextArrow) {
            throw new Error('Slider element not found');
        }
        jQuery(this.slider).slick({
            prevArrow: this.prevArrow,
            nextArrow: this.nextArrow,
            asNavFor: `#${this.captionsID}`,
            lazyLoad: 'progressive',
            rows: 0,
        });
        if (this.captionsSlider) {
            jQuery(this.captionsSlider).slick({
                arrows: false,
                fade: true,
                rows: 0,
                draggable: false,
                swipe: false,
            });
        }
    }
}
export default function resonImages() {
    const slider = document.querySelectorAll('.reason-images');
    for (const element of slider) {
        if (element.querySelector('.reason-images-slider')) {
            new ReasonImages(element);
        }
    }
}
